// From Relay TMS
enum CheckCallSource {
  Dispatcher = 'dispatcher',
  Driver = 'driver',
  Shipper_Receiver = 'shipper/receiver',
  Web = 'web',
}

export default CheckCallSource;
